import Table from './Table.vue';

Table.install = (Vue) => {
  Vue.component(Table.name, Table);
};

export default Table;
